import React from "react";
import "./OverlaySlider.css";
import leftArrow from "./icons/left-arrow.svg";
import rightArrow from "./icons/right-arrow.svg";

export default function BtnSlider({ direction, moveSlide }) {
  return (
    <button
      onClick={moveSlide}
      className={
        direction === "next"
          ? "overlay_btn-slide overlay_next"
          : "overlay_btn-slide overlay_prev"
      }
    >
      <img src={direction === "next" ? rightArrow : leftArrow} />
    </button>
  );
}
